<template>
  <div class="activity-warp">
    <div class="activity-head">
      <img class="backicon" src="../../assets/imgs/close.png" @click="onBack">
      <div class="activity-title">实名认证</div>
    </div>
    <div style="margin: 10px">
      <div class="my-certity">
        <label>我的流量卡认证</label>
      </div>
      <div class="s-b">
        <div class="round">
          <van-image :src="require('assets/imgs/mifi17.png')" width="50px" height="50px;" style="margin-top: 8px"></van-image>
        </div>
        <div class="sup-name">
          <label>中国电信</label>
        </div>
        <div class="to-c">
          <div class="to-t">
            <label class="color-1ebe86">去实名</label>
          </div>
        </div>
      </div>
      <div class="t-c m300150">
        <van-button class="text-certify">去实名</van-button>
      </div>
      <div class="t-c">
        <label class="color-1ebe86">同步实名</label>
      </div>
      <div class="text-num-b m40">
        <div class="text-tip color-666666">工信部《电话用户真实身份信息登记规定》中规定，物联网卡与使用人一一对应，必须办理实际使用人的的实名登记，未实名流量卡将依法停止通信服务。</div>
        <div class="text-tip p10 color-ff1919">您的实名资料信息将直接上传国家工信部系统，请不用担心信息安全泄露问题。</div>
      </div>
      <div class="text-num-b m20">
        <div class="text-num color-ff1919">温馨提示</div>
        <div class="text-num text-num-p3">1.实名认证运营商进行审核，审核期间网络暂不可用;</div>
        <div class="text-num text-num-p3">2.审核过后请重启设备，若设备网络不可用，请联系客服;</div>
        <div class="text-num text-num-p3">3.若实名状态未同步，请点击下方按钮进行实名状态同步;</div>
        <div class="text-num text-num-p3">4.凌晨时段，实名系统关闭,请勿频操作.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ORDER_LIST } from '../../apis/user'
import { mapState } from "vuex";
import { MIFI_PRODUCT_CANCEL_ORDERS, MIFI_PRODUCT_ORDERS, MIFI_PRODUCT_REPAY } from "@/apis/cabinet";
export default {
  components: {
  },
  computed: {
    ...mapState(['mifisn'])
  },
  data () {
    return {
    }
  },
  methods: {
    onBack () {
      this.$router.go(-1)
    },
    backHome() {
      this.$router.push('/')
    }
  },
  created () {
  }
}
</script>

<style lang="less">
.activity-warp {
  height: 100vh;
  // background: linear-gradient(#00AB46, #1A2229);
  background: #F4F4F4;
  .activity-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

    .backicon {
      width: 50px;
    }
    .activity-title {
      text-align: center;
      width: 100%;
      font-family: Montserrat, Montserrat;
      font-weight: bold;
      font-size: 36px;
      color: #1A2229;
    }
  }
}
.round{
  width: 130px;
  height: 130px;
  background: white;
  text-align: center;
  border-radius: 65px
}
.sup-name{
  margin: 50px 0 0 30px;
  font-family: MyFont6;
  font-size: 12pt;
  color: white;
}
.to-c{
  font-family: MyFont6;
  font-size: 7pt;
  margin: 62px 0 0 40px;
}
.to-t{
  background: white;
  padding: 2px 6px;
  border-radius: 8px
}
.s-b{
  display: flex;
  background: #1EBE86;
  border-radius: 18px;
  padding: 20px;
}
.my-certity{
  padding: 10px 0;
  font-family: MyFont6;
  font-size: 12pt
}
.t-c{
  text-align: center
}
.text-num-b{
  background: white;
  padding: 15px;
  border-radius: 8px;
}
.m10{
  margin-top: 10px;
}
.m20{
  margin-top: 20px;
}
.m40{
  margin-top: 80px;
}
.text-num{
  color: #666666;
  font-family: MyFont8;
  font-size: 8pt;
}
.text-num-p3{
  padding: 3px 0
}
.color-ff1919{
  color: #FF1919
}
.color-666666{
  color: #666666;
}
.color-1ebe86{
  color: #1EBE86
}

.text-tip{
  font-family: MyFont8;
  font-size: 9pt
}
.p10{
  padding: 10px 0 0 0
}
.text-certify{
  width: 100%;
  background: #1EBE86 !important;;
  color: white !important;;
  border-radius: 20px !important;;
  font-family: MyFont7 !important;;
  font-size: 13pt !important;
}
.m300150{
  margin: 60px 0 30px 0;
}
</style>
